export default __webpack_public_path__ + "static/media/gift_animation.ad913d5d.gif";